import { CommunityRules } from "@/components/legal/CommunityRules";

export const CommentsRulesPage = () => {
  return <CommunityRules />;
};
